import React, {useEffect} from 'react';
import {useSelector} from 'react-redux';
import {useToast} from '@dishtech-react/hooks';
import Progress from '../../../../helpers/progress';

const ResultsNotification = () => {
  const {createToast} = useToast();
  const {errorStatus, errorMessage, loading} = useSelector(state => state?.results);

  useEffect(() => {
    if (!loading && errorMessage !== '') {
      createToast(`${errorStatus && `${errorStatus}, `}${errorMessage}`, {
        variant: 'error',
        persist: true,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, errorMessage]);

  return <>{loading && <Progress title="Loading" />}</>;
};
export default ResultsNotification;
